import { action, createAction, createStandardAction } from 'typesafe-actions'
import { createErrorAction } from '@chegg-wt/core/utils/actions'
import { SortKey } from '@chegg-wt/core/constants/projects'
import { Citation } from '@chegg-wt/core/types/redux-citation-api'
import { ActionTypes } from './constants'
import { CreateNewCitationPayload } from './types'

// async delete citations actions
export const deleteCitations = (citations: Citation[]) =>
  action(ActionTypes.DELETE_CITATIONS, { citations })
export const deleteCitationsFailed = createErrorAction(
  ActionTypes.DELETE_CITATIONS_FAILED
)

// async fetch citations actions
export const fetchCitations = (projectId: string) =>
  action(ActionTypes.FETCH_CITATIONS, { projectId })
export const fetchCitationsFailed = createErrorAction(ActionTypes.FETCH_CITATIONS_FAILED)
export const fetchCitationsSucceeded = (citations) =>
  action(ActionTypes.FETCH_CITATIONS_SUCCEEDED, { citations })

// pagination actions
export const setCitationPage = createAction(
  ActionTypes.SET_CITATIONS_PAGE,
  (action) => (page: number) => action({ page })
)

// citation menu actions
export const editCitation = createAction(
  ActionTypes.EDIT_CITATION,
  (action) => (citation: Citation) => action({ citation })
)

export const editCitationError = createErrorAction(ActionTypes.EDIT_CITATION_ERROR)

// UI actions
export const sortCitations = (sortKey: SortKey) =>
  action(ActionTypes.SORT_CITATIONS, { sortKey })
export const toggleCitationCheckbox = (citationId: string) =>
  action(ActionTypes.TOGGLE_CITATION_CHECKBOX, { citationId })

export const selectAllCitations = createStandardAction(ActionTypes.SELECT_ALL_CITATIONS)()

export const deselectAllCitations = createStandardAction(
  ActionTypes.DESELECT_ALL_CITATIONS
)()

export const createNewCitation = createAction(
  ActionTypes.CREATE_NEW_CITATION,
  (action) => (payload: CreateNewCitationPayload) => action(payload)
)

export const setCitationValidityVariation = (citationValidityVariation: string) =>
  action(ActionTypes.SET_CITATION_VALIDITY_VARIATION, {
    citationValidityVariation,
  })
